<div class="overflow-x-auto rounded-xl border border-[#EAEAEA] dark:border-line bg-white dark:bg-surface-1">
  <table class="min-w-full text-sm">
    <thead class="bg-slate-50 dark:bg-white/5 text-[11px] uppercase tracking-wide text-gray-500 dark:text-ink-soft/50">
      <tr>
        <th class="px-3 py-2 text-left font-medium">Session</th>
        <th class="px-3 py-2 text-left font-medium">Company</th>
        <th class="px-3 py-2 text-left font-medium">Host</th>
        <th class="px-3 py-2 text-left font-medium">AI Agent</th>
        <th class="px-3 py-2 text-left font-medium">Guests</th>
        <th class="px-3 py-2 text-left font-medium">Duration</th>
        <th class="px-3 py-2 text-left font-medium">Status</th>
        <th class="px-3 py-2 text-left font-medium">Location</th>
        <th class="px-3 py-2 text-left font-medium">IP</th>
        <th class="px-3 py-2 text-left font-medium">Browser</th>
        <th class="px-3 py-2 text-left font-medium">OS</th>
        <th class="px-3 py-2 text-left font-medium">Device</th>
        <th class="px-3 py-2 text-left font-medium">Source</th>
        <th class="px-3 py-2 text-left font-medium">Network</th>
        <th class="px-3 py-2 text-right font-medium">Actions</th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-100 dark:divide-line/60">
      @for (s of sessions; track s.sessionId) {
        <tr class="hover:bg-slate-50 dark:hover:bg-line/40 cursor-pointer" (click)="rowClick.emit(s)">
          <td class="px-3 py-2 font-mono text-xs text-gray-700 dark:text-gray-200">{{ shortId(s.sessionId) }}</td>
          <td class="px-3 py-2 text-gray-700 dark:text-gray-200">{{ s.companyName || '—' }}</td>
          <td class="px-3 py-2 text-gray-700 dark:text-gray-200">{{ s.hostName || '—' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ s.aiAgentName || 'AI' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ s.guestCount }}</td>
          <td class="px-3 py-2 tabular-nums text-gray-700 dark:text-gray-200">{{ liveDuration(s.startedAt, now) }}</td>
          <td class="px-3 py-2">
            <span class="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset" [class]="statusClass(s.status)">
              <span class="h-1.5 w-1.5 rounded-full" [class]="statusDot(s.status)"></span>
              {{ statusLabel(s.status) }}
            </span>
          </td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ location(s) }}</td>
          <td class="px-3 py-2 font-mono text-xs text-gray-600 dark:text-gray-300">{{ s.security?.ip || '—' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ s.security?.browser || '—' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ s.security?.os || '—' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300 capitalize">{{ s.security?.deviceType || '—' }}</td>
          <td class="px-3 py-2 whitespace-nowrap">
            @if (s.security?.appPlatform) {
              <span class="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/20 dark:bg-emerald-400/10 dark:text-emerald-300">{{ launchSourceLabel(s.security) }}</span>
            } @else {
              <span class="text-gray-600 dark:text-gray-300">{{ launchSourceLabel(s.security) }}</span>
            }
          </td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-300">{{ s.security?.networkType || '—' }}</td>
          <td class="px-3 py-2">
            <div class="flex items-center justify-end gap-1">
              <button type="button" title="View details" (click)="emit('view', s, $event)"
                class="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-white/10 dark:hover:text-white">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              </button>
              @if (isLive(s)) {
                <button type="button" title="Watch live screen" aria-label="Watch live screen" (click)="emit('screen', s, $event)"
                  class="rounded-md p-1.5 text-rose-500 hover:bg-rose-50 hover:text-rose-700 dark:hover:bg-rose-500/10">
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/><circle cx="12" cy="10" r="2" fill="currentColor"/></svg>
                </button>
              }
              @if (canJoin(s)) {
                <button type="button" title="Join room (covert observer)" (click)="emit('join', s, $event)"
                  class="rounded-md p-1.5 text-indigo-500 hover:bg-indigo-50 hover:text-indigo-700 dark:hover:bg-white/5">
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 10l4.55-2.28A1 1 0 0 1 21 8.62v6.76a1 1 0 0 1-1.45.9L15 14"/><rect x="3" y="6" width="12" height="12" rx="2"/></svg>
                </button>
              }
              <button type="button" title="Participants" (click)="emit('participants', s, $event)"
                class="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-white/10 dark:hover:text-white">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              </button>
              @if (isLive(s)) {
                <button type="button" title="Disconnect session" (click)="emit('disconnect', s, $event)"
                  class="rounded-md p-1.5 text-amber-600 hover:bg-amber-50 hover:text-amber-700 dark:hover:bg-amber-500/10">
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"/><line x1="23" y1="1" x2="1" y2="23"/></svg>
                </button>
              }
              <button type="button" title="Blacklist IP" (click)="emit('blacklist', s, $event)"
                [disabled]="!s.security?.ip"
                class="rounded-md p-1.5 text-red-500 hover:bg-red-50 hover:text-red-700 disabled:opacity-30 disabled:cursor-not-allowed dark:hover:bg-red-500/10">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
              </button>
            </div>
          </td>
        </tr>
      } @empty {
        <tr><td colspan="15" class="px-3 py-10 text-center text-sm text-gray-400">No sessions match your filters.</td></tr>
      }
    </tbody>
  </table>
</div>
